<template>
  <card>
    <template slot="header">
      <h4 class="card-title">Aufgaben</h4>
      <p class="category"></p>
    </template>
    <div class="table-full-width table-tasks">
      <table class="table">
        <tbody>
        <task v-for="(task, index) in tasks"
              :key="task.title"
              :task="task"
              :index="index"
              @on-edit="handleTaskEdit"
              @on-delete="handleTaskDelete">

        </task>
        </tbody>
      </table>
    </div>
    <template slot="footer">
      <hr>
      <div class="stats">
        <i class="fa fa-history"></i> vor 4 Stunden zuletzt gändert
      </div>
    </template>
  </card>
</template>
<script>
  import Task from './Task.vue'
  import { Card } from 'src/components/UIComponents'

  export default {
    components: {
      Task,
      Card
    },
    data() {
      return {
        tasks: [
          {
            done: true,
            title: 'Gespräch mit Andrew Mike'
          },
          {
            done: false,
            title: 'Team Besprechung zu den Auswirkungen der letzten Änderungen'
          },
          {
            done: false,
            title: 'Team Überlast - zusätzliche Ressourcen prüfen'
          },
          {
            done: true,
            title: 'Gespräch mit Thomas Albrecht zur schlechten letzten Reflektion'
          },
          {
            done: false,
            title: 'Nächsten Schritte zu Motivationssteigerung in Team 4 in die Wege leiten'
          }
        ]
      }
    },
    methods: {
      handleTaskEdit(index) {
        alert(`You want to edit task: ${JSON.stringify(this.tasks[index])}`)
      },
      handleTaskDelete(index) {
        alert(`You want to delete task: ${JSON.stringify(this.tasks[index])}`)
      }
    }
  }
</script>
<style>
</style>
